<template>
	<div>
		<div class="bf-mob-body">
			<section
				class="d-flex align-items-center justify-content-center"
				v-if="!submitted"
			>
				<div
					:class="{
						active: currentSection === 1,
						'bf-grey-tab':
							currentSection !== 1 &&
							(form.aboutMe.length === 0 || form.portfolio.length === 0),
						'bf-green-tab':
							currentSection != 1 &&
							(form.aboutMe.length > 0 || form.portfolio.length > 0),
						'bf-half-green-tab': currentSection === 1,
					}"
					class="d-flex align-items-center justify-content-center position-relative pointer"
					@click="currentSection = 1"
				>
					01
					<div
						:class="{
							'bf-text-pos-grey':
								currentSection !== 1 &&
								(form.aboutMe.length === 0 || form.portfolio.length === 0),
							'bf-text-pos-green':
								currentSection != 1 &&
								(form.aboutMe.length > 0 || form.portfolio.length > 0),
							'bf-text-pos-black': currentSection === 1,
						}"
						class="bf-text-pos"
					>
						Your bio
					</div>
				</div>
				<div class="bf-green-line"></div>
				<div
					:class="{
						'bf-grey-tab': currentSection !== 2 && form.categories.length === 0,
						'bf-green-tab': currentSection != 2 && form.categories.length > 0,
						'bf-half-green-tab': currentSection === 2,
					}"
					class="d-flex align-items-center justify-content-center position-relative pointer"
					@click="goToSection(2)"
				>
					02
					<div
						:class="{
							'bf-text-pos-grey':
								currentSection !== 2 && form.categories.length === 0,
							'bf-text-pos-green':
								currentSection != 2 && form.categories.length > 0,
							'bf-text-pos-black': currentSection === 2,
						}"
						class="bf-text-pos"
					>
						Course information
					</div>
				</div>
				<div
					class="bf-green-line"
					v-if="currentSection === 3 || form.selectedOptions.length > 0"
				></div>
				<div class="bf-grey-line" v-else></div>
				<div
					:class="{
						active: currentSection === 3,
						'bf-grey-tab':
							currentSection !== 3 && form.selectedOptions.length === 0,
						'bf-green-tab':
							currentSection != 3 && form.selectedOptions.length > 0,
						'bf-half-green-tab': currentSection === 3,
					}"
					class="d-flex align-items-center justify-content-center position-relative pointer"
					@click="goToSection(3)"
				>
					03
					<div
						:class="{
							active: currentSection === 3,
							'bf-text-pos-grey':
								currentSection !== 3 && form.selectedOptions.length === 0,
							'bf-text-pos-green':
								currentSection !== 3 && form.selectedOptions.length > 0,
							'bf-text-pos-black': currentSection === 3,
						}"
						class="bf-text-pos"
					>
						Additional info
					</div>
				</div>
			</section>

			<section :class="submitted ? 'bf-scroll-2' : ' bf-scroll'">
				<template v-if="currentSection === 1 && !submitted">
					<div class="fam-mont fw-M text-344054 fs-16 mb-2">
						1. Tell us about yourself and your career?
						<span class="color-red">*</span>
					</div>
					<div>
						<b-form-textarea
							:class="{ 'bf-red-border': errors.aboutMe }"
							@input="clearError('aboutMe'), updateContinue()"
							v-model="form.aboutMe"
							placeholder="Enter your answer here"
							rows="4"
							no-resize
						></b-form-textarea>
						<div class="asp-redtxt" v-if="errors.aboutMe">
							{{
								form.aboutMe.length > 1024
									? "Maximum 1024 characters allowed"
									: "Required"
							}}
						</div>
						<div class="fam-lato fw-LM text-lightgrey bf-fs-12 mt-2">
							This informations will be displayed in your profile page which
							will be visible to students in our platform.
						</div>
					</div>
					<div class="fam-mont fw-M text-344054 fs-16 mt-3">
						2. Attach your portfolio <span class="fw-R bf-fs-16">(Max. 3)</span>
						<span class="color-red">*</span>
					</div>
					<div
						v-for="(portfolioItem, index) in form.portfolio"
						:key="index"
						class="d-flex align-items-center gap-3 mt-2"
					>
						<b-form-input
							:disabled="index < form.portfolio.length - 1"
							v-model="form.portfolio[index]"
							@input="validatePortfolioLink(index), clearError('portfolio')"
							:class="{
								'bf-red-border': portfolioErrors[index],
							}"
							placeholder="https://"
						></b-form-input>
						<img
							v-if="
								index === form.portfolio.length - 1 &&
								form.portfolio.length < maxportfolio
							"
							:class="
								portfolioErrors[index] || !form.portfolio[index]
									? 'opac-5'
									: 'pointer'
							"
							src="../assets/newdesign/home/Become/blue-plus.svg"
							alt="Add"
							@click="addPortfolioInput()"
						/>
						<img
							v-else
							class="pointer"
							src="../assets/newdesign/home/Become/delete-bin.svg"
							alt="Delete"
							@click="removePortfolio(index)"
						/>
					</div>

					<div
						class="asp-redtxt"
						v-if="errors.portfolio && form.portfolio.length === 0"
					>
						Required
					</div>
					<div
						v-for="(error, index) in portfolioErrors"
						:key="'error-' + index"
					>
						<div class="asp-redtxt" v-if="error && form.portfolio[index]">
							Enter Valid Link
						</div>
					</div>
				</template>

				<template v-if="currentSection === 2 && !submitted">
					<div class="fam-mont fw-M text-344054 fs-16 mb-3">
						What type of course will you be creating?
						<span class="asp-redtxt"
							>*<span v-if="errors.categories">Required</span></span
						>
					</div>
					<div class="d-flex flex-wrap gap-2">
						<!-- Render Predefined Categories -->
						<div
							v-for="(category, index) in predefinedCategories"
							:key="index"
							:class="{
								'bf-red-border': errors.categories,
								'bf-green-tag': form.categories.includes(category),
								'bf-white-tag': !form.categories.includes(category),
							}"
							class="d-flex align-items-center gap-2 pointer"
							@click="toggleCategory(category)"
						>
							<img
								v-if="form.categories.includes(category)"
								src="../assets/newdesign/home/Become/white-tick.svg"
								alt=""
							/>
							<img
								v-else
								src="../assets/newdesign/home/Become/blue-circle.svg"
								alt=""
							/>
							{{ category }}
						</div>

						<!-- Add Custom Category -->
						<div
							class="bf-white-tag d-flex align-items-center gap-2 pointer"
							v-if="!form.showCustomInput"
							@click="form.showCustomInput = true"
							:class="{ 'bf-red-border': errors.categories }"
						>
							<img src="../assets/newdesign/home/Become/plus.svg" alt="" />
							Others
						</div>
						<div
							class="bf-white-tag d-flex align-items-center gap-2"
							:class="errors.categoryExists ? 'bf-red-border' : ''"
							v-else
						>
							<img
								@click="addCustomCategory"
								src="../assets/newdesign/home/Become/blue-circle.svg"
								alt=""
							/>
							<b-form-input
								v-model="form.newCategory"
								autofocus
								placeholder="Enter your category"
								@keyup.enter="addCustomCategory"
							/>
						</div>
						<div
							v-if="errors.categoryExists"
							class="candash-errortxt d-flex align-items-center"
						>
							This category already exists!
						</div>
					</div>
				</template>

				<template v-if="currentSection === 3 && !submitted">
					<div class="fam-mont fw-M text-344054 fs-16 mb-3">
						Why do you want to become an instructor with us?
						<span class="asp-redtxt">*</span>
					</div>
					<div class="">
						<b-form-group>
							<b-form-checkbox-group
								stacked
								:options="options"
								@change="updateContinue()"
								v-model="form.selectedOptions"
								class="instructor-checkbox"
							>
							</b-form-checkbox-group>
						</b-form-group>
					</div>
				</template>

				<template v-if="submitted">
					<div
						class="d-flex flex-column align-items-center justify-content-center bf-gap-30 h-100"
					>
						<img src="../assets/newdesign/home/Become/laptop-done.svg" alt="" />
						<span class="fam-mont fw-M bf-fs-24 text-344054"
							>Submitted successfully!</span
						>
						<h5 class="text-center fam-mont fw-R text-344054 bf-fs-16">
							Thanks you for your interest in becoming an instructor with us.
							Our team will analyse your profile and get back to you shortly
							with the next steps
						</h5>
					</div>
				</template>
			</section>

			<div id="hideinlaptop" class="mobjd-applied-footer w-100 px-3">
				<div class="mob-cancelBtn w-50">
					<b-button class="w-100" @click="goBack" v-if="!submitted"
						>Back</b-button
					>
				</div>
				<div class="mob-addBtn position-relative w-50">
					<b-button
						class="w-100"
						:disabled="continueDisabled || buttonLoader"
						@click="continueNext()"
						>{{ submitted ? "Okay got it" : "Continue" }}</b-button
					>
					<div v-if="buttonLoader" class="loader-pos-new">
						<Loader />
					</div>
				</div>
			</div>
		</div>
		<div
			id="hideinmobile"
			class="candash-modal-footer d-flex align-items-center justify-content-end"
		>
			<b-button
				class="candash-cancelBtn mr-3 pointer"
				style="width: 110px"
				@click="goBack"
				v-if="!submitted"
				>Back</b-button
			>
			<div class="position-relative">
				<b-button
					class="candash-addBtn"
					:disabled="continueDisabled || buttonLoader"
					@click="continueNext()"
					>{{ submitted ? "Okay got it" : "Continue" }}</b-button
				>
				<div v-if="buttonLoader" class="loader-pos-new">
					<Loader />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { postApplication, getUserDetails } from "@/utils/apiFunctions";
import { trackInstructorApplied } from '@/utils/posthogHelpers';
import toast from "./mixin/toast";
import Loader from "./fixedcomponents/Loader.vue";

export default {
	props: {
		currentStep: {
			type: Number,
			required: false,
		},
	},
	components: {
		Loader,
	},
	mixins: [toast],
	watch: {
		currentStep(newStep) {
			if (newStep <= 3) {
				this.currentSection = newStep;
			}
			if (newStep == 4) {
				this.currentSection === 3;
				this.continueNext();
			}
		},

		currentSection(newSection) {
			this.currentSection = newSection;
			this.$emit("update:currentStep", newSection);
			this.updateContinue();
		},

		"form.newCategory"(newVal) {
			const lowerNewVal = newVal.toLowerCase();
			this.errors.categoryExists = this.predefinedCategories.some(
				(category) => category.toLowerCase() === lowerNewVal
			);
		},

		"form.portfolio": {
			handler() {
				this.updateContinue();
				this.validateAllPortfolioLinks();
			},
			deep: true,
		},
	},

	data() {
		return {
			form: {
				aboutMe: "",
				portfolio: [""],
				newPortfolio: "",
				categories: [],
				customCategories: [],
				showCustomInput: false,
				newCategory: "",
				selectedOptions: [],
			},

			errors: {
				aboutMe: false,
				portfolio: false,
				categories: false,
				categoryExists: false,
			},
			buttonLoader: false,

			portfolioErrors: [false],

			continueDisabled: true,
			submitted: false,
			maxportfolio: 3,
			currentSection: this.currentStep || 1,

			predefinedCategories: [
				"Artificial Intelligence",
				"Web Development",
				"Data Science",
				"Cybersecurity",
			],

			options: [
				{
					text: "Actively searching for a job",
					value: "actively searching for a job",
				},
				{ text: "Want to teach students", value: "want to teach students" },
				{
					text: "Looking for new opportunities",
					value: "looking for new opportunities",
				},
				{
					text: "Want to to explore online teaching",
					value: "want to to explore online teaching",
				},
				{
					text: "Looking to earn income through online courses",
					value: "looking to earn income through online courses",
				},
			],
		};
	},

	methods: {
		clearError(field) {
			this.errors[field] = false;
		},
		goBack() {
			if (this.currentSection > 1) {
				this.currentSection -= 1;
			} else {
				if (window.innerWidth >= 1028) {
					this.$emit("closeModal");
				} else {
					this.$router.go(-1);
				}
			}
		},

		updateContinue() {
			if (
				this.currentSection === 1 &&
				(!this.form.aboutMe.trim() ||
					this.form.aboutMe.length > 1024 ||
					!this.hasValidPortfolio())
			) {
				if (this.submitted || this.form.aboutMe.length > 0) {
					this.errors.aboutMe =
						!this.form.aboutMe.trim() || this.form.aboutMe.length > 1024;
				}
				this.errors.portfolio = !this.hasValidPortfolio();
				this.continueDisabled = true;
			} else if (
				this.currentSection === 2 &&
				this.form.categories.length === 0
			) {
				this.continueDisabled = true;
			} else if (
				this.currentSection === 3 &&
				this.form.selectedOptions.length === 0
			) {
				this.continueDisabled = true;
			} else {
				this.continueDisabled = false;
			}
			this.$emit("update:continueDisabled", this.continueDisabled);
		},
		hasValidPortfolio() {
			return this.form.portfolio.some((link) => {
				const trimmed = link.trim();
				return trimmed && this.isValidUrl(trimmed);
			});
		},
		isValidUrl(string) {
			try {
				new URL(string);
				return true;
			} catch (_) {
				return false;
			}
		},

		goToSection(section) {
			// Validate section 1 requirements
			if (
				section === 2 &&
				(!this.form.aboutMe.trim() ||
					this.form.aboutMe.length > 1024 ||
					!this.hasValidPortfolio())
			) {
				this.errors.aboutMe =
					!this.form.aboutMe.trim() || this.form.aboutMe.length > 1024;
				this.errors.portfolio = !this.hasValidPortfolio();
				return;
			}

			if (
				(section === 3 && this.form.categories.length === 0) ||
				!this.form.aboutMe.trim() ||
				!this.hasValidPortfolio()
			) {
				this.errors.aboutMe = !this.form.aboutMe.trim();
				this.errors.portfolio = !this.hasValidPortfolio();
				this.errors.categories = this.form.categories.length === 0;
				return;
			}

			this.currentSection = section;
		},

		addPortfolioInput() {
			if (this.form.portfolio.length < this.maxportfolio) {
				const lastIndex = this.form.portfolio.length - 1;
				const lastLink = this.form.portfolio[lastIndex].trim();

				if (lastLink && this.isValidUrl(lastLink)) {
					this.form.portfolio.push("");
					this.portfolioErrors.push(false);
				}
			}
		},

		validatePortfolioLink(index) {
			const link = this.form.portfolio[index].trim();

			if (!link) {
				this.portfolioErrors[index] = false;
				return;
			}
			this.portfolioErrors[index] = !this.isValidUrl(link);
		},

		validateAllPortfolioLinks() {
			this.form.portfolio.forEach((link, index) => {
				this.validatePortfolioLink(index);
			});
		},

		async continueNext() {
			if (this.submitted) {
				// ✅ Only close when "Okay got it" is clicked
				const isLaptop = window.innerWidth >= 1024;
				this.$emit("form-submitted", this.submitted);
				if (isLaptop) {
					this.$emit("closeModal");
				} else {
					this.$router.go(-1);
				}
				return;
			}

			if (this.currentSection === 3) {
				const validPortfolioLinks = this.form.portfolio.filter((link) => {
					const trimmed = link.trim();
					return trimmed && this.isValidUrl(trimmed);
				});

				this.buttonLoader = true;
				const res = await getUserDetails();
				const data = {
					firstName: res.data.data.firstName,
					lastName: res.data.data.lastName,
					email: res.data.data.email,
					phone: res.data.data.phoneNumber,
					about: this.form.aboutMe,
					portfolio: validPortfolioLinks,
					categories: this.form.categories,
					why: this.form.selectedOptions,
				};

				try {
					const resp = await postApplication(data);
					if (resp.status === 200) {
						// ✅ Show success screen but don’t close modal yet
						this.submitted = true;
						trackInstructorApplied({
							email:res.data.data.email,
						})
						this.successModal("Submitted", "Instructor application submitted");
					} else {
						this.errorModal("Error", "Something went wrong..");
					}
				} catch (error) {
					console.error("Error while submitting application:", error);
					this.errorModal("Error", "Something went wrong..");
				} finally {
					this.buttonLoader = false;
				}
			} else {
				this.currentSection += 1;
			}
		},

		addNewIndex() {
			if (
				this.form.newPortfolio.trim() &&
				this.errors.invalidPortfolio === false
			) {
				this.form.newIndex += 1;
				this.form.portfolioList = [...this.form.portfolio];
				this.form.newPortfolio = "";
			}
		},

		addPortfolio() {
			if (
				this.form.newPortfolio.trim() &&
				this.form.portfolio.length < this.maxportfolio
			) {
				if (this.form.newIndex < 0) this.form.newIndex = 0;
				this.form.portfolio[this.form.newIndex] = this.form.newPortfolio.trim();
				this.updateContinue();
			}
		},

		removePortfolio(index) {
			if (this.form.portfolio.length > 1) {
				this.form.portfolio.splice(index, 1);
				this.portfolioErrors.splice(index, 1);
			} else {
				// If it's the only input, just clear it
				this.form.portfolio[0] = "";
				this.portfolioErrors[0] = false;
			}
		},

		toggleCategory(category) {
			this.errors.categories = false;
			const index = this.form.categories.indexOf(category);

			if (index > -1) {
				this.form.categories.splice(index, 1);

				const customIndex = this.form.customCategories.indexOf(category);
				if (customIndex > -1) {
					// If it's a custom category, remove it from all arrays
					this.form.customCategories.splice(customIndex, 1);
					const predefinedIndex = this.predefinedCategories.indexOf(category);
					if (predefinedIndex > -1) {
						this.predefinedCategories.splice(predefinedIndex, 1);
					}
				}
			} else {
				this.form.categories.push(category);
			}
			this.updateContinue();
		},

		addCustomCategory() {
			const trimmedCategory = this.form.newCategory.trim();
			const lowerNewCategory = trimmedCategory.toLowerCase();

			const isDuplicate =
				this.form.categories.some(
					(cat) => cat.toLowerCase() === lowerNewCategory
				) ||
				this.predefinedCategories.some(
					(cat) => cat.toLowerCase() === lowerNewCategory
				);

			if (trimmedCategory && !isDuplicate) {
				this.form.categories.push(trimmedCategory);
				this.predefinedCategories.push(trimmedCategory);
				this.form.customCategories.push(trimmedCategory);
				this.form.newCategory = "";
				this.form.showCustomInput = false;
			}

			this.updateContinue();
		},
	},
};
</script>
<style>
.bf-red-border {
	border: 1px solid #ff0000 !important;
}
.color-red {
	color: #ff0000 !important;
}
.bf-green-tab {
	height: 40px;
	width: 40px;
	border-radius: 50%;
	background-color: #0a9362;
	font-family: "Roboto", sans-serif;
	font-size: 16px;
	font-weight: 500;
	color: #ffffff;
	border: 2px solid #0a9362;
}
.bf-half-green-tab {
	height: 40px;
	width: 40px;
	border-radius: 50%;
	background-color: #ffffff;
	font-family: "Roboto", sans-serif;
	font-size: 16px;
	font-weight: 500;
	color: #0a9362;
	border: 2px solid #0a9362;
}
.bf-grey-tab {
	height: 40px;
	width: 40px;
	border-radius: 50%;
	background-color: #ffffff;
	font-family: "Roboto", sans-serif;
	font-size: 16px;
	font-weight: 500;
	color: #c5c5c5;
	border: 2px solid #c5c5c5;
}
.bf-green-line {
	height: 4px;
	width: 200px;
	background-color: #0a9362;
}
.bf-grey-line {
	height: 4px;
	width: 200px;
	background-color: #c5c5c5;
}
.bf-text-pos {
	font-family: "Inter", sans-serif;
	font-size: 14px;
	font-weight: 500;
	white-space: nowrap;
	top: 45px;
	position: absolute;
}
.bf-text-pos-green {
	color: #0a9362;
}
.bf-text-pos-black {
	color: #0d0b26;
}
.bf-text-pos-grey {
	color: #8c8c8c80;
}
.fs-16 {
	font-size: 18px;
}
.bf-fs-16 {
	font-size: 16px;
}
.bf-scroll {
	height: unset;
	max-height: unset;
	overflow: auto;
	margin-top: 50px;
	padding-bottom: 10px;
}
.bf-scroll-2 {
	height: 100%;
	overflow: auto;
	padding-bottom: 10px;
}
.bf-scroll .form-control {
	border-radius: 8px;
	border: 1px solid #d0d5dd;
	font-family: "Montserrat", sans-serif;
	font-size: 14px;
	font-weight: 500;
	color: #333333;
}
.bf-scroll .form-control::placeholder {
	font-family: "Montserrat", sans-serif;
	font-size: 14px;
	font-weight: 400;
	color: #667085;
}
.bf-scroll .form-control:focus {
	box-shadow: none;
}
.bf-scroll .form-control:disabled {
	background-color: #ecf0f4;
	border: 1px solid #ecf0f4;
	font-family: "Montserrat", sans-serif;
	font-size: 14px;
	font-weight: 500;
	color: #333333;
}
.bf-fs-12 {
	font-size: 12px;
}
.bf-white-tag {
	border: 1px solid #8c8c8c4d;
	border-radius: 20px;
	font-family: "Inter", sans-serif;
	font-size: 16px;
	font-weight: 400;
	color: #333333;
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 5px 13px;
}
.bf-green-tag {
	border: 1px solid #8c8c8c4d;
	border-radius: 20px;
	font-family: "Inter", sans-serif;
	font-size: 16px;
	font-weight: 400;
	color: #ffffff;
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 5px 13px;
	background-color: #009045;
}
.bf-white-tag .form-control {
	border: none;
	border-bottom: 1px solid #afafaf;
	border-radius: 0;
	padding: 0;
	height: 24px;
}
.bf-scroll .custom-control-input:checked ~ .custom-control-label::before {
	color: #fff;
	border-color: #20639b;
	background-color: #20639b;
	box-shadow: none;
}
.bf-scroll .custom-control-label::before {
	border: 1.5px solid #595959;
}
.bf-scroll .custom-control-label {
	font-family: "Montserrat", sans-serif;
	font-size: 16px;
	font-weight: 400;
	color: #0d0d0d;
}
.bf-scroll .custom-control {
	min-height: 50px;
}
.bf-fs-24 {
	font-size: 24px;
}
.bf-gap-30 {
	gap: 30px;
}
.bf-mob-body {
	padding: 20px;
	height: calc(100vh - 345px);
	overflow: auto;
	max-height: 485px;
}
@media (max-width: 1028px) {
	.bf-mob-body {
		/* position: fixed; */
		top: unset;
		width: 100%;
		height: calc(
			100dvh - (60px + env(safe-area-inset-top) + env(safe-area-inset-bottom))
		);
		max-height: unset;
		padding: 20px 0 0 0;
	}
	.bf-scroll {
		height: calc(93% - 108px);
		max-height: unset;
		overflow: auto;
		margin-top: 50px;
		padding: 20px;
		padding-bottom: unset;
	}
	.bf-grey-line,
	.bf-green-line {
		width: 100px !important;
	}
	.bf-text-pos {
		font-size: 12px;
	}
	.fs-16,
	.bf-fs-16 {
		font-size: 14px;
	}
	.bf-fs-12 {
		font-size: 10px;
		line-height: 13px;
	}
	.bf-scroll .form-control::placeholder {
		font-size: 13px;
	}
	.bf-scroll .form-control,
	.bf-scroll .form-control:disabled {
		font-size: 13px !important;
	}
	.bf-white-tag {
		font-size: 13px;
	}
	.bf-green-tag {
		font-size: 13px;
	}
	.bf-white-tag .form-control {
		height: 20px;
	}
	.bf-scroll .custom-control-label {
		font-size: 14px;
		line-height: 24px;
	}
	.bf-fs-24 {
		font-size: 16px;
	}
	.bf-scroll-2 {
		height: 92%;
		overflow: auto;
		padding-inline: 20px;
		padding-bottom: unset;
	}
}

.instructor-checkbox .custom-control-label {
	cursor: pointer;
}
</style>
